import { SiteIdOverrideConfig } from "stores/wizard/config";
import { timeValues24HoursFormat } from "src/components/shared/TimeDropdown/config/time/timeValues";

export const siteId70916: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://a.travel-assets.com/travel-assets-manager/cmct-2135/KR_Autumn_Bukhansan_1400x600.jpg",
  },
  package: {
    showAllSubLOB: false,
  },
  car: {
    date: {
      queryParam: {
        start: "",
        end: "",
      },
    },
    form: {
      action: "https://rent-a-car.expedia.co.kr/{locale}-kr/book#/vehicles",
    },
    timeValues: timeValues24HoursFormat,
    defaultShowingTime: "10:30",
    isCarTrawler: true,
    includeGT: false,
    showVendorOptions: false,
    clientID: 312054,
    residenceID: "KR",
  },
  hotel: {
    packageRatesTermsUrl: "/static/default/default/taap/contracts/hpr/KR.HPR.012021.pdf",
  },
};
